import {
  AlphabeticalAsc,
  AlphabeticalDesc,
  Newest,
  Oldest,
  SortDirection,
  SortDropdownOption
} from '@hevoio/hevo-ui-toolkit';

export const WORKSPACE_SORT_OPTIONS: SortDropdownOption[] = [
  {
    label: Newest,
    key: 'created_ts',
    direction: SortDirection.DESC
  },
  {
    label: Oldest,
    key: 'created_ts',
    direction: SortDirection.ASC
  },
  {
    label: AlphabeticalAsc,
    key: 'name',
    direction: SortDirection.ASC
  },
  {
    label: AlphabeticalDesc,
    key: 'name',
    direction: SortDirection.DESC
  }
];
